export default "__VITE_ASSET__00e004a8__"